import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import React, { useCallback, useState } from 'react';
import { deleteProductDetail } from '../../../api/products';

export default function DeleteProductSpec({ fetchData, detail, token }) {
  const [error, setError] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  const handleDelete = useCallback(async () => {
    const response = await deleteProductDetail(detail.id, token);
    if (response.ok) {
      fetchData();
    } else {
      setError('Failed to delete product detail. Please try again.');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detail, fetchData]);

  const handleDeleteButtonClick = () => {
    setDeleteConfirmationOpen(true);
  };

  const handleDeleteConfirm = () => {
    handleDelete();
    setDeleteConfirmationOpen(false);
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmationOpen(false);
  };

  return (
    <>
      <IconButton
        size="small"
        sx={{ p: 2, color: 'darkred' }}
        onClick={handleDeleteButtonClick}>
        <DeleteOutlinedIcon />
      </IconButton>
      <Dialog
        open={deleteConfirmationOpen}
        onClose={handleDeleteCancel}
        fullWidth
        maxWidth="sm">
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Typography>
            Are you sure you want to delete <strong>{detail.type}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
